export const DEMO_REQUEST = "https://calendly.com/10speed/demo";
